import React from "react";
import Header from "../components/LandingPage/Header";
import Hero from "../components/LandingPage/Hero";
import CompaniesMarquee from "../components/LandingPage/CompaniesMarquee";
import Features from "../components/LandingPage/Features";
import ReviewStats from "../components/LandingPage/ReviewStats";
import Testimonials from "../components/LandingPage/Testimonials";
import Footer from "../components/LandingPage/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Header />
      <main>
        <Hero />
        <CompaniesMarquee />
        <Features />
        <ReviewStats />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;